import React, { useEffect, useState } from "react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import "../../resources/styles/home.scss";
import NavBar from "./components/NavBar";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import image1 from "../../resources/images/slide1.avif";
import image2 from "../../resources/images/slide2.avif";
import image3 from "../../resources/images/slide3.avif";
import image4 from "../../resources/images/slide4.avif";
//
import { ReactComponent as PersonIcon } from "../../resources/images/person.svg";

import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../controllers/reducers/products";
import SideMenu from "./components/SideMenu";
import { RootState } from "../..";
import { setUser } from "../../controllers/reducers/user";
import { api } from "../../controllers/api";
import { User, ShoppingCart } from "lucide-react";
type ContextType = { showMenu: Boolean };
function Home() {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector((state: RootState) => state);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const handleShowMenu = () => {
    if (!showMenu) {
      setShowMenu(true);
      document.body.classList.add("no-scroll");
    } else handleCloseMenu();
  };
  const handleCloseMenu = () => {
    setShowMenu(false);
    document.body.classList.remove("no-scroll");
  };
  const handleClick = (e: React.SyntheticEvent) => {
    let target = e.target as HTMLElement;
    if (!target.closest(".slide-in") && !target.closest(".hamburger")) {
      handleCloseMenu();
    }
    if (!target.closest(".nav-bar__one__account-con__account-options")) {
      setShowProfileMenu(false);
    }
  };

  const verifyUserToken = async () => {
    try {
      let req = await fetch(api + "/verify-user", {
        headers: { Authorization: "Bearer " + user?.token },
      });
      if (req.ok) {
        let res = await req.json();
        dispatch(setUser(res));
      } else navigate("/auth/login");
    } catch (error) {}
  };

  useEffect(() => {
    if (user) verifyUserToken();
    dispatch(fetchProducts());
  }, []);
  const handleMenu = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    if (!user) {
      navigate("/auth/login", { state: location.pathname });
      return;
    }
    setShowProfileMenu(!showProfileMenu);
  };
  return (
    <div onClick={handleClick} className="home-con">
      {user ? (
        <>
          {" "}
          <NavBar
            menu={{ showMenu, handleShowMenu }}
            profileMenu={{ handleMenu, showMenu: showProfileMenu }}
          />
          <SideMenu handleMenu={{ showMenu, handleCloseMenu }} />
          <Outlet context={{ showMenu }} />
        </>
      ) : (
        <div className="landing-page">
          <div className="landing-page__header">
            {" "}
            <ShoppingCart
              color="green"
              onClick={() => {
                if (user) navigate("/cart");
                else navigate("/auth/login", { state: "/cart" });
              }}
            />
            <Link to={"/auth/login"} className="landing-page__header__button">
              <User /> <p>Sign in</p>
            </Link>
            <Link to={"auth/signup"} className="landing-page__header__button">
              <p>Create Account</p>
            </Link>
          </div>

          <section className="section">
            <img src={image1} alt="landing" />
            <h3>Learn about EasyMeds.ng</h3>
            <p>
              “On a mission to become the leading B2B platform for medicine
              distribution” or “Thousands of verified vendors. Millions of
              healthcare products. One platform.” Frequently searched:
              Paracetamol, Omeprazole, SKG, Wellkid
            </p>
          </section>

          <section className="section">
            <img src={image2} alt="" />
            <p></p>
            <p>
              🛒 Whatever you need, whenever you need it Easily find and order
              essential medical supplies to keep your outlet stocked and
              protected from price shocks.
            </p>
            <p>
              🛡️ Verified quality and secure transactions Buy confidently from
              licensed vendors with built-in protection from payment to
              delivery.
            </p>
            <p>
              {" "}
              🔄 One platform, endless possibilities Handle browsing, ordering,
              payment, and delivery all in one simple platform.
            </p>
            <p>
              {" "}
              🎯 Personalized buying experience Get cost-saving tools, purchase
              rewards, vendor reviews, bulk discounts, and smart recommendations
              tailored to your business.
            </p>
          </section>

          <section className="section">
            <img src={image3} alt="" />
          </section>
        </div>
      )}
    </div>
  );
}

export default Home;
export const useShowMenu = () => useOutletContext<ContextType>();
